import store from "context/vendors/store";

export const setFlashMessage = (message) => store.getActions().app.setFlashMessage({ message });
